// Sami SALEラベルを商品画像内へ移動

function moveSamiLabels() {
  document.querySelectorAll('.product').forEach(function (product) {
    const link = product.querySelector('.no-height.center.image > a');
    const image = link?.querySelector('img');
    const label = product.querySelector('.samita-container');

    if (!link || !image || !label) return;

    let imageWrapper = link.querySelector('.product-image-label-area');

    if (!imageWrapper) {
      imageWrapper = document.createElement('div');
      imageWrapper.className = 'product-image-label-area';

      link.insertBefore(imageWrapper, image);
      imageWrapper.appendChild(image);
    }

    if (!imageWrapper.contains(label)) {
      imageWrapper.appendChild(label);
    }
  });
}

document.addEventListener('DOMContentLoaded', moveSamiLabels);

const samiLabelObserver = new MutationObserver(moveSamiLabels);

samiLabelObserver.observe(document.body, {
  childList: true,
  subtree: true
});